import { isAxiosError } from "axios";
//#region src/shared/utils/extract-api-error.ts
function extractApiError(error) {
	if (isAxiosError(error)) {
		const apiError = error.response?.data;
		return {
			message: apiError?.error || error.message,
			apiError
		};
	}
	return { message: error?.message };
}
//#endregion
export { extractApiError };

//# sourceMappingURL=extract-api-error.js.map